import Rules from './index'

export default Rules
